import Cookies from 'js-cookie';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

const TOKEN_KEY = 'token';

const isNative = () => {
  try { return Capacitor?.isNativePlatform?.() === true; } catch { return false; }
};

export const authStorage = {
  async getToken() {
    if (isNative()) {
      try {
        const { value } = await Preferences.get({ key: TOKEN_KEY });
        return value || null;
      } catch (_) { return null; }
    }
    return Cookies.get(TOKEN_KEY) || null;
  },

  async setToken(token, days = 7) {
    if (isNative()) {
      try { await Preferences.set({ key: TOKEN_KEY, value: token }); } catch {}
      return;
    }
    Cookies.set(TOKEN_KEY, token, { expires: days });
  },

  async removeToken() {
    if (isNative()) {
      try { await Preferences.remove({ key: TOKEN_KEY }); } catch {}
      return;
    }
    Cookies.remove(TOKEN_KEY);
  }
};


